module.exports = __webpack_public_path__ + "static/a-front-view-of-woman-having-breakfast-in-bed-in-YXTU5LD-324f98de3dda025d8572643d585d9b40.jpg";